import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKycClock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.3333 6.33333V14.3333L19.6667 17M27.6667 14.3333C27.6667 21.6971 21.6971 27.6667 14.3333 27.6667C6.96954 27.6667 1 21.6971 1 14.3333C1 6.96954 6.96954 1 14.3333 1C21.6971 1 27.6667 6.96954 27.6667 14.3333Z",
		stroke: "#BF7109",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgKycClock;
